import { PageController } from '@client/components/_core/layout/PageController';
import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { createFileRoute } from '@tanstack/react-router';
import { Result } from 'antd';

export const Route = createFileRoute('/(authentication)/payment-pending')({
    component: PaymentPending,
});

function PaymentPending() {
    return (
        <PageController route={Route}>
            <div className="grid h-screen w-full place-items-center bg-background">
                <Result
                    status="warning"
                    title="Account Top Up Required"
                    subTitle={
                        <div className="text-center">
                            <p>Your account balance needs to be topped up to continue using the service.</p>
                            <p className="mt-2">
                                We have sent an invoice to your email address with instructions on how to add funds to
                                your account.
                            </p>
                            <div className="mt-6">
                                <Button.Link to="/login" variant="link">
                                    Back to login
                                </Button.Link>
                            </div>
                        </div>
                    }
                    className="mx-auto w-full max-w-lg rounded-lg bg-card p-8 shadow-xs"
                />
            </div>
        </PageController>
    );
}
